var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _div;

import React from 'react';
import PropTypes from 'prop-types';
import DropDownArrow from 'material-ui/svg-icons/navigation/arrow-drop-down';
import FloatingLabel from './FloatingLabel';

var objectShape = PropTypes.shape({
  value: PropTypes.any.isRequired,
  label: PropTypes.string
});

var styles = {
  div1: (_div = {
    position: 'relative',
    display: '-webkit-box'
  }, _div['display'] = '-webkit-flex', _div['display'] = '-moz-box', _div['display'] = '-ms-flexbox', _div['display'] = '-o-flex', _div['display'] = 'flex', _div.WebkitBoxPack = 'end', _div.WebkitJustifyContent = 'flex-end', _div.msFlexPack = 'end', _div.OJustifyContent = 'flex-end', _div.justifyContent = 'flex-end', _div.WebkitAlignItems = 'center', _div.MozAlignItems = 'center', _div.msAlignItems = 'center', _div.OAlignItems = 'center', _div.alignItems = 'center', _div),
  div2: {
    WebkitBoxFlex: 1,
    MozBoxFlex: 1,
    WebkitFlex: 1,
    msFlex: 1,
    OFlex: 1,
    flex: 1
  }
};

var SelectionsPresenter = function SelectionsPresenter(_ref) {
  var selectedValues = _ref.selectedValues,
      selectionsRenderer = _ref.selectionsRenderer,
      floatingLabel = _ref.floatingLabel,
      hintText = _ref.hintText,
      muiTheme = _ref.muiTheme,
      floatingLabelStyle = _ref.floatingLabelStyle,
      floatingLabelFocusStyle = _ref.floatingLabelFocusStyle,
      underlineStyle = _ref.underlineStyle,
      underlineFocusStyle = _ref.underlineFocusStyle,
      isFocused = _ref.isFocused,
      isOpen = _ref.isOpen,
      disabled = _ref.disabled,
      errorText = _ref.errorText;
  var _muiTheme$textField = muiTheme.textField,
      floatingLabelColor = _muiTheme$textField.floatingLabelColor,
      borderColor = _muiTheme$textField.borderColor,
      focusColor = _muiTheme$textField.focusColor;

  // Condition for animating floating Label color and underline

  var focusCondition = isFocused || isOpen;
  // Condition for shrinking the floating Label
  var shrinkCondition = Array.isArray(selectedValues) && !!selectedValues.length || !Array.isArray(selectedValues) && (typeof selectedValues === 'undefined' ? 'undefined' : _typeof(selectedValues)) === 'object' && selectedValues != null || focusCondition;

  var errorStyle = { borderColor: 'rgb(244,67,54)', borderWidth: 2 };
  var disabledStyle = { borderBottom: '2px dotted' };

  var baseHRstyle = _extends({
    position: 'absolute',
    bottom: 0,
    left: 0,
    width: '100%',
    margin: 0,
    boxSizing: 'content-box',
    borderTop: 'none',
    borderLeft: 'none',
    borderRight: 'none',
    borderBottom: '1px solid',
    borderColor: borderColor
  }, underlineStyle);

  var focusedHRstyle = disabled ? disabledStyle : errorText ? errorStyle : _extends({
    borderBottom: '2px solid',
    borderColor: focusCondition ? focusColor : borderColor,
    transition: '450ms cubic-bezier(0.23, 1, 0.32, 1)', // transitions.easeOut(),
    transform: 'scaleX( ' + (focusCondition ? 1 : 0) + ' )'
  }, underlineFocusStyle);

  return React.createElement(
    'div',
    null,
    React.createElement(
      'div',
      { style: styles.div1 },
      React.createElement(
        'div',
        { style: styles.div2 },
        floatingLabel && React.createElement(
          'div',
          { style: { marginBottom: 6 } },
          React.createElement(
            FloatingLabel,
            {
              shrink: shrinkCondition || hintText,
              focusCondition: focusCondition,
              disabled: disabled,
              defaultColors: { floatingLabelColor: floatingLabelColor, focusColor: focusColor },
              floatingLabelStyle: _extends({}, floatingLabelStyle, { pointerEvents: 'none' }),
              floatingLabelFocusStyle: floatingLabelFocusStyle },
            floatingLabel
          )
        ),
        (shrinkCondition || !floatingLabel || hintText) && React.createElement(
          'div',
          null,
          selectionsRenderer(selectedValues, hintText, floatingLabelColor)
        )
      ),
      React.createElement(DropDownArrow, { style: { fill: borderColor } }),
      !(focusCondition || errorText || disabled) && React.createElement('hr', { style: baseHRstyle }),
      React.createElement('hr', { style: _extends({}, baseHRstyle, focusedHRstyle) })
    ),
    errorText && React.createElement(
      'div',
      { style: { paddingTop: 6, fontSize: 12, color: 'rgb(244,67,54)' } },
      errorText
    )
  );
};

SelectionsPresenter.propTypes = process.env.NODE_ENV !== "production" ? {
  value: PropTypes.oneOfType([objectShape, PropTypes.arrayOf(objectShape)]),
  selectionsRenderer: PropTypes.func,
  hintText: PropTypes.string
} : {};

SelectionsPresenter.defaultProps = {
  value: null,
  selectionsRenderer: function selectionsRenderer(values, hintText, hintColor) {
    var hintDiv = React.createElement(
      'div',
      { style: { color: hintColor } },
      hintText
    );
    if (!values) return hintDiv;
    var value = values.value,
        label = values.label;

    if (Array.isArray(values)) {
      return values.length ? values.map(function (_ref2) {
        var value = _ref2.value,
            label = _ref2.label;
        return label || value;
      }).join(', ') : hintDiv;
    } else if (label || value) return label || value;else return hintDiv;
  }
};

export default SelectionsPresenter;


//////////////////
// WEBPACK FOOTER
// ./~/mui-selectfield-search/es/SelectionPresenter.js
// module id = 3824
// module chunks = 0